import { getRandomIntInclusive } from '@application/utils';
import { InputLabel, InputWrapper, MtFormContainer, SkeletonBox } from '@presentation/components';
import { useCallback, useMemo } from 'react';
import * as RootStyled from '../../styled';

export const PageSkeleton = () => {
  const skeletons = useMemo(
    () => ({
      title: { width: `${getRandomIntInclusive(30, 40)}%`, height: 40, marginBottom: 20 },
      form: {
        section1: {
          image: {
            label: { width: `${getRandomIntInclusive(30, 40)}%`, height: 15 },
            inputField: { width: `${getRandomIntInclusive(80, 95)}%`, height: 250 },
          },
          fields: Array(3)
            .fill(undefined)
            .map(() => ({
              label: { width: `${getRandomIntInclusive(30, 40)}%`, height: 15 },
              inputField: { width: `${getRandomIntInclusive(50, 90)}%`, height: 45 },
            })),
        },
        section2: {
          fields: Array(2)
            .fill(undefined)
            .map(() => ({
              label: { width: `${getRandomIntInclusive(30, 40)}%`, height: 15 },
              inputField: { width: `${getRandomIntInclusive(30, 45)}%`, height: 45 },
            })),
        },
        field: {
          label: { width: `${getRandomIntInclusive(30, 40)}%`, height: 15 },
          inputField: { width: `${getRandomIntInclusive(50, 90)}%`, height: 45 },
        },
      },
    }),
    [],
  );

  const skeletonFormField = useCallback(
    () => (
      <InputWrapper>
        <InputWrapper split>
          <InputLabel>
            <SkeletonBox style={skeletons.form.field.label} />
          </InputLabel>
          <SkeletonBox style={skeletons.form.field.inputField} />
        </InputWrapper>
      </InputWrapper>
    ),
    [skeletons],
  );

  return (
    <RootStyled.Wrapper>
      <MtFormContainer>
        <div>
          <SkeletonBox style={skeletons.title} />
        </div>

        <InputWrapper split>
          {skeletons.form.section1.fields.map((field, index) => (
            <InputWrapper key={index}>
              <InputLabel required>
                <SkeletonBox style={field.label} />
              </InputLabel>
              <SkeletonBox style={field.inputField} />
            </InputWrapper>
          ))}
        </InputWrapper>

        <InputWrapper split last>
          <InputLabel>
            <SkeletonBox style={skeletons.form.section1.image.label} />
          </InputLabel>
          <RootStyled.ProfilePictureWrapper>
            <SkeletonBox style={skeletons.form.section1.image.inputField} />
          </RootStyled.ProfilePictureWrapper>
        </InputWrapper>

        {skeletonFormField()}
      </MtFormContainer>
    </RootStyled.Wrapper>
  );
};
